/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './dataDetail.less';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import StationDetailApi from '../api/stationDetailApi';
import { CommonUtil } from 'src/util/commonUtil';
import EnumDivisor from 'src/enums/enumDivisor';
let bem = createBEM('data-detail');

@Component
export default class DataDetail extends Vue.Component<any> {
    mn: string = '';
    productId: number = 0
    dataList: {cn_type: string,data: string, data_time: string, divisor: string}[][] = []
    async search() {
        let {code, data} = await StationDetailApi.searchDataDetail(this.mn, this.productId)
        if(code === 0) {
            let result = CommonUtil.groupBy(data.body, 'divisor')
            this.dataList = Object.values(result)
        }
    }
    mounted() {
        this.mn = this.$route.query.mn;
        this.productId = +this.$route.query.productId;
        this.search();
        Bus.$on(Events.StationChange, this.stationChange);
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.productId = data.product_id;
        this.search();
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
    }
    render(h) {
        return (
            <div class={bem()}>
                {this.dataList.map(i => {
                    return (
                        <div class={bem('card')}>
                            <div class={bem('card-title')}>{EnumDivisor.findCode(i[0].divisor).getName()}水质分析仪</div>
                            <div class={bem('card-head')}>
                                <div style="width: 130px">时间</div>
                                <div style="flex: 1">测量类型</div>
                                <div style="flex: 1">测量值</div>
                            </div>
                            <div class={bem('card-body')}>
                                {
                                    i.map(sub=> {
                                        return  <div class={bem('card-row')}>
                                        <div style="width: 130px">{sub.data_time}</div>
                                    <div style="flex: 1">{sub.cn_type}</div>
                                    <div style="flex: 1">{sub.data}</div>
                                    </div>
                                    })
                                }
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
